import { gql } from '@eti/schema-types';

export const CONTACT_US_SUPPORT_FAQ = gql(/* GraphQL */ `
  query getContactUsSupportFaq($sectionSlug: String!) {
    faq(faqType: MY_PORTAL, sectionSlug: $sectionSlug) {
      sections {
        questionAndAnswers {
          answer
          question
          slug
        }
        slug
        title
      }
    }
  }
`);
